import React, { useState, useRef } from 'react'
import PropTypes from 'prop-types'
import {
  Button, ListContainer, Container, List, ButtonText, HiddenInput
} from './styles'
import Option from './Option'
import { Required, Instructions } from '../../layout/mixins'

const Dropdown = ({
  placeholder, options, active, onChange, name, half, third, required, instructions
}) => {
  const [open, setOpen] = useState(false)
  const [changed, setChanged] = useState(false)
  const inputRef = useRef()

  const removeEventListeners = () => {
    document.removeEventListener('keydown', onKeydown)
    document.removeEventListener('click', onClick)
  }

  const onKeydown = (event) => {
    if (event.keyCode == 27) {
      setOpen(false)
      removeEventListeners()
    }
  }

  const onClick = () => {
    setOpen(false)
    removeEventListeners()
  }


  const toggleList = (key) => {
    if (!open) {
      document.addEventListener('keydown', onKeydown)
      document.addEventListener('click', onClick)
    } else if (options.find((option) => option.key === key)) {
      setChanged(true)
      onChange(key)
    }
    setOpen((toggle) => !toggle)
  }

  const valid = required && active


  const renderList = () => {
    if (options.length) {
      return (
        <ListContainer open={open}>
          <List>
            {options.map((option) => (
              <Option
                label={option.label}
                key={option.key}
                active={active === option.key}
                onChange={() => toggleList(option.key)}
              />
            ))}
          </List>
        </ListContainer>
      )
    }

    return null
  }
  const label = active ? options.find((option) => option.key === active).label : placeholder
  const value = active ? options.find((option) => option.key === active).label : ''

  return (

    <Container third={third} half={half}>
      { required ? <HiddenInput ref={inputRef} defaultValue={value} required name={name} /> : null }
      <Button
        type="button"
        changed={changed}
        onClick={toggleList}
        open={open}
        required={required}
        valid={valid}
      >
        <ButtonText>{ label }</ButtonText>
      </Button>
      { required ? (
        <Required inset>*</Required>
      ) : null }
      {renderList()}
      {instructions ? (
        <Instructions>{instructions}</Instructions>
      ) : null}
    </Container>
  )
}

export default Dropdown

Dropdown.propTypes = {
  placeholder: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired
    })
  ).isRequired,
  name: PropTypes.string.isRequired,
  half: PropTypes.bool,
  third: PropTypes.bool,
  required: PropTypes.bool,
  instructions: PropTypes.string
}

Dropdown.defaultProps = {
  placeholder: 'Välj ett alternativ',
  half: false,
  third: false,
  required: false,
  instructions: null
}